import React from 'react';
import TeamCard from './TeamCard';
import { bet_department, fiscal_council, mag, marketing_department, ped_department, rec_department, sust_deparment } from '../data/teamData';
import { board } from '../data/teamData';

function Team() {
    return (
        <section id="team">
            <p class="anchor" id="estrutura"></p>
            <div className="container wow fadeInUp">
                <div className="section-header">
                    <h3 className="section-title">Estrutura</h3>
                    <p className="section-description">Membros constituintes do Núcleo de Estudantes de Engenharia Química da FEUP</p>
                </div>
                <h2>Direção</h2>
                <hr />
                <div className="row justify-content-center">
                    {board.slice(0, 3).map((member, index) =>
                        <TeamCard key={index} member={member} />
                    )}
                </div>
                <div className="row justify-content-center">
                    {board.slice(3, 5).map((member, index) =>
                        <TeamCard key={index} member={member} />
                    )}
                </div>
                <h2>Departamentos</h2>
                <hr />
                <div className="row justify-content-center">
                    {ped_department.map((member, index) =>
                        <TeamCard key={index} member={member} />
                    )}
                </div>
                <div className="row justify-content-center">
                    {rec_department.map((member, index) =>
                        <TeamCard key={index} member={member} />
                    )}
                </div>
                <div className="row justify-content-center">
                    {marketing_department.map((member, index) =>
                        <TeamCard key={index} member={member} />
                    )}
                </div>
                <div className="row justify-content-center">
                    {sust_deparment.map((member, index) =>
                        <TeamCard key={index} member={member} />
                    )}
                </div>
                <h2>Building Engineers of Tomorrow</h2>
                <hr />
                <div className="row justify-content-center">
                    {bet_department.map((member, index) =>
                        <TeamCard key={index} member={member} />
                    )}
                </div>
                <h2>Mesa da Assembleia Geral</h2>
                <hr />
                <div className="row justify-content-center">
                    {mag.map((member, index) =>
                        <TeamCard key={index} member={member} />
                    )}
                </div>
                <h2>Conselho Fiscal</h2>
                <hr />
                <div className="row justify-content-center">
                    {fiscal_council.map((member, index) =>
                        <TeamCard key={index} member={member} />
                    )}
                </div>
            </div>
        </section>
    );
}

export default Team;